import * as React from "react";
import { Props } from "../../types/global";
import { TopupService } from "../services/topup-service";
import { GTMDataLayer } from "../services/gtm-datalayer";
import { messageDialog } from "../dialogs/MessageDialog";
import t from "../i18n";
import { Loading } from "../common/Loading";

export declare type PaypalProps = Props<undefined, { sid: string, token: string, PayerID: string }>;
export class Paypal extends React.Component<PaypalProps> {
    async componentDidMount() {
        const query = this.props.location.query;
        if (query.sid && query.token && query.PayerID) {
            try {
                const response = await TopupService.processPaypalTransaction(query.sid, query.token, query.PayerID);
                if (response.responseCode === 0) {
                    if(response.payLoad.receipt.rechargeStatus === 1){
                        GTMDataLayer.transactionComplete(response.payLoad!.receipt);
                    }
                    if(response.payLoad!.receipt.guestTransactionId){
                        this.props.history.push(`/receipt?guestTrxId=${response.payLoad!.receipt.guestTransactionId}`);
                    }
                    else {
                        this.props.history.push(`/receipt?transactionId=${response.payLoad.receipt.transactionId}`);               
                    }
                }
                else if(response.responseCode === -1){
                    await messageDialog(response.responseMessage, t.common("oops"));
                    await this.props.history.push(`/`);
                }
                else {
                    this.props.history.push(`/timeout?sessionId=${query.sid}`);
                }
            } catch (e) {
                if (e.code === "ECONNABORTED") {
                    this.props.history.push(`/timeout?sessionId=${query.sid}`);
                } else {
                    messageDialog(t.error("error_contact_support"), t.menu("send_balance"));
                }
            }
        }
    }
    render() {
        return <Loading />;
        // return (
        //     <div>
        //         <div>Please wait while your transaction is being processed</div>
        //         <div>Need to provide nice processing spinner</div>
        //         <div>sid: {this.props.location.query.sid}</div>
        //         <div>token: {this.props.location.query.token}</div>
        //         <div>payerId: {this.props.location.query.PayerID}</div>
        //     </div>
        // );
    }
}